'use client'
import { useEffect } from 'react'

/**
 * runs a 'reset' function, whenever isSubmitSuccessfull is true
 */
export const useRunResetOnSubmitSuccessfull = (
  isSubmitSuccessful: boolean,
  reset: () => void,
): void => {
  useEffect(() => {
    if (isSubmitSuccessful) {
      reset()
    }
  }, [isSubmitSuccessful, reset])
}
